export const chatMessages = [
    {
      id: 1,
      expertId: 'carlos',
      sender: 'user',
      message: 'Olá Carlos, tenho uma dúvida sobre minhas roseiras.',
      time: '10:05',
      status: 'read'
    },
    {
      id: 2,
      expertId: 'carlos',
      sender: 'expert',
      message: 'Olá João! Como posso ajudar com suas roseiras?',
      time: '10:07',
      status: 'read'
    },
    {
      id: 3,
      expertId: 'carlos',
      sender: 'user',
      message: 'Elas não estão florescendo bem ultimamente. Acho que pode ser falta de sol. O que você acha?',
      time: '10:15',
      status: 'read'
    },
    {
      id: 4,
      expertId: 'carlos',
      sender: 'expert',
      message: 'Sim, as rosas precisam de bastante sol direto. Elas devem receber pelo menos 6 horas de luz solar por dia para florescer bem. Em que local do jardim elas estão?',
      time: '10:32',
      status: 'read'
    },
    {
        id: 5,
        expertId: 'ana',
        sender: 'user',
        message: 'Olá Ana, meu gramado está com algumas manchas amareladas. O que pode ser?',
        time: '09:40',
        status: 'read'
    },
    {
        id: 6,
        expertId: 'ana',
        sender: 'expert',
        message: 'Bom dia! Isso pode ser falta de nutrientes ou excesso de água. Você tem irrigado com frequência?',
        time: '09:42',
        status: 'read'
    },
    {
        id: 7,
        expertId: 'ana',
        sender: 'user',
        message: 'Tenho irrigado quase todos os dias pela manhã.',
        time: '09:45',
        status: 'read'
    },
    {
        id: 8,
        expertId: 'ana',
        sender: 'expert',
        message: 'Nesse caso, o ideal é irrigar de 2 a 3 vezes por semana, dependendo do clima. Irrigação em excesso pode causar fungos.',
        time: '09:47',
        status: 'read'
    },
    {
        id: 9,
        expertId: 'ana',
        sender: 'expert',
        message: 'Recomendo irrigar pela manhã, evitando a evaporação.',
        time: '09:47',
        status: 'read'
    },
    {
        id: 10,
        expertId: 'ricardo',
        sender: 'user',
        message: 'Boa tarde Ricardo, minha piscina está ficando esverdeada rapidamente. O que posso fazer?',
        time: '14:10',
        status: 'read'
    },
    {
        id: 11,
        expertId: 'ricardo',
        sender: 'expert',
        message: 'Boa tarde! Isso geralmente é sinal de algas. Você tem aplicado cloro regularmente?',
        time: '14:12',
        status: 'read'
    },
    {
        id: 12,
        expertId: 'ricardo',
        sender: 'user',
        message: 'Faz umas duas semanas que não aplico.',
        time: '14:13',
        status: 'read'
    },
    {
        id: 13,
        expertId: 'ricardo',
        sender: 'expert',
        message: 'O ideal é aplicar cloro semanalmente e monitorar o pH da água. Recomendo fazer uma supercloração agora e aspirar o fundo no dia seguinte.',
        time: '14:15',
        status: 'read'
    }
];

export const experts = [
    {
        id: 'carlos',
        name: 'Carlos Oliveira',
        role: 'Paisagista',
        avatar: 'green',
        online: true,
        lastMessage: 'Sim, as rosas precisam de bastante sol direto. Elas devem receber pelo menos 6 horas de luz solar por dia para florescer bem. Em que local do jardim elas estão?',
        unread: 1,
        time: '10:32'
    },
    {
        id: 'ana',
        name: 'Ana Sousa',
        role: 'Especialista em Gramados',
        avatar: 'blue',
        online: true,
        lastMessage: 'Recomendo irrigar pela manhã, evitando a evaporação.',
        unread: 0,
        time: 'Ontem'
    },
    {
        id: 'ricardo',
        name: 'Ricardo Gomes',
        role: 'Técnico em Piscinas',
        avatar: 'purple',
        online: false,
        lastMessage: 'O ideal é aplicar cloro semanalmente e monitorar o pH da água. Recomendo fazer uma supercloração agora e aspirar o fundo no dia seguinte.',
        unread: 0,
        time: '25/03'
    }
];